<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Store Toppings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">{{ this.store.name }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addToppingModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Add Toppings
                </button>
            </div>

        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.store.name }} Toppings</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allToppings"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#" @click.prevent="showAlert(props.row.topping.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>

                <div class="modal fade add-topping-modal" tabindex="-1" role="dialog"
                     aria-labelledby="myLargeModalLabel"
                     aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <form @submit.prevent="addTopping">
                                <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                                    Add Topping</h4>
                                    <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                        aria-hidden="true">×</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="form-group col-12">
                                            <div class="controls">
                                                <label class="form-label">Product Size</label>
                                                <select v-model="newTopping" id="" class="form-control"
                                                        required>
                                                    <option value="" selected>Select a Topping to add to the store
                                                    </option>
                                                    <option v-for="topping in toppings" :key="topping.id"
                                                            :value="topping.id">
                                                        {{ topping.topping_name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button class="btn btn-primary" :disabled="saving">
                                        Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Store Toppings Details'},
    props: ['store', 'toppings', 'storeToppings'],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            allToppings: [],
            baseUrl: '',
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },
            newTopping: "",
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Topping Name', field: 'topping.topping_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Price', field: 'topping.price', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Created At', field: 'created_at', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
            saving: false,

        }
    },

    mounted() {
        this.baseUrl = window.location.origin;
        this.allToppings = this.storeToppings.data;
        this.totalRecords = this.storeToppings.total
        console.log(this.toppings)
    },

    methods: {
        addToppingModal() {
            $('.add-topping-modal').modal('show');
            this.newTopping = ""
        },
        async paginatedData() {
            try {
                let routeName = 'admin.stores.toppings';

                let response = await axios.get(route(routeName, this.store.id), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allToppings = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async showAlert(toppingId) {
            const details = {
                title: "Are you sure you want to delete the topping from this store?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteTopping(toppingId) : "";
        },
        async deleteTopping(toppingId) {
            this.$inertia.delete(route('admin.stores.toppings.delete', [this.store.id, toppingId,]), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },
        async addTopping() {
            this.saving = true;
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: async () => {
                    this.saving = false
                    await this.paginatedData();
                }
            };
            this.$inertia.post(route('admin.stores.toppings.create', [this.store.id, this.newTopping]), options);
            this.newTopping = "";
            $('.add-topping-modal').modal('hide');
        },

    }
}
</script>
